// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"618":"4e625e61","1503":"a88472b9","2279":"84b8fb08","6609":"928cbd28","6953":"5368a474","9421":"928cbd28"}[chunkId] + ".chunk.css";
};